import { Divider } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect } from "react";
import { tokens } from "styles/Tokens";
import ButtonLink from "../Link";
import Typography from "../Typography";
import "./KeyMetrics.scss";
interface Props {
  keyMetricsData: any;
  label?: string;
  helperText?: string;
  hyperLink?: any;
}

const SnapShotItem = (props: any) => {
  const { title, data, subTitle, isPrimary = false, showBorder = false, index, metricsLength } = props;
  const snapshotBorder = showBorder ? "snapshot-border" : "snapshot-noBorder";
  const showDividerIndex = metricsLength > 3 && Math.ceil(metricsLength / 2);
  const showDivider = index + 1 === showDividerIndex;

  return (
    <>
      <Box
        className={
          isPrimary ? "snapshot-container-primary item" : `snapshot-container-notPrimary ${snapshotBorder} item`
        }
      >
        <Typography variant="label">{title}</Typography>
        <Typography showBold variant="h3">
          {data || 0}
        </Typography>
        <Typography variant="label">{subTitle}</Typography>
      </Box>
      {showDivider && <Divider className="snapshot-divider-show"></Divider>}
    </>
  );
};

const KeyMetrics = (props: Props) => {
  const { keyMetricsData, label = "", helperText = "", hyperLink } = props;

  useEffect(() => {
    const container: any = document.querySelector(".key-metrics-container");
    const items: any = container.querySelectorAll(".item");
    const containerWidth: any = container.clientWidth;

    let rowWidth = 0;
    let lastIndex = 0;

    items.forEach((item: any, index: number) => {
      rowWidth += item.clientWidth;

      // Check if adding this item exceeds the container's width
      if (rowWidth > containerWidth) {
        items[lastIndex].style.borderRight = "none";
        rowWidth = item.clientWidth;
        return;
      }

      lastIndex = index;
    });
  }, []);
  return (
    <div className="key-metrics-component">
      <Typography variant="body1" showBold color={tokens.Text.General.Secondary}>
        {label}
      </Typography>
      <div className="key-metrics-container">
        {keyMetricsData?.map((element: any, index: number) => {
          return (
            <SnapShotItem
              key={element.title}
              isPrimary={element.isPrimary}
              title={element.title}
              subTitle={element.subTitle}
              showBorder={element.showBorder}
              data={element.data}
              metricsLength={keyMetricsData?.length}
              index={index}
            />
          );
        })}
      </div>
      <div className="key-metrics-helper">
        {helperText && (
          <div className="key-metrics-helper-text">
            {" "}
            <Typography variant={"label"} color={tokens.Text.General.Tertiary}>
              {helperText}
            </Typography>{" "}
          </div>
        )}
        {hyperLink && (
          <ButtonLink
            text={hyperLink.content}
            sx={{ color: tokens.Text.General.Color }}
            textVariant="body2"
            underline="none"
            onClick={() => window.open(hyperLink.link)}
          />
        )}
      </div>
    </div>
  );
};

export default KeyMetrics;
